export const findroomByInfo = (activityInfo) => {
  
  try{
    if(activityInfo.data.settings.chatmode === 'chatroom'){
        return "/forum/modes/chatroom";
    }
    if(activityInfo.data.settings.chatmode === 'sticker'){
      return "/forum/modes/sticker";
    }
    if(activityInfo.data.settings.chatmode === 'tagged-forum'){
      return "/forum/modes/tagged-forum";
    }
    if(activityInfo.data.settings.chatmode === 'workspace'){
      return "/forum/modes/workspace";
    }
    return "/forum/modes/sticker";
  }catch(error){
    if(activityInfo.data === undefined){
      return "/forum/modes/sticker";
    }
    console.error(error);
    return "/forum/modes/sticker";
  }
};


